import { GeneralPaywallMeta } from '@7chairs/types';
import { Plan } from '../../../../types/plan';
import { WEEKLY_PRICES_TEST_DEFAULT_PLAN_KEY } from '../../PickAProduct/PickAProduct.types';
import { ProductV3 } from '../ProductV3';
import {
  PickPlanSectionV2Content,
  PickPlanSectionV2Products,
  PickPlanSectionV2Title,
  PickPlanSectionV2Wrapper,
} from './PickAPlanSectionV2.style';

interface PickPlanSectionV2Props {
  planPositions: string[];
  stripePlans: Record<string, Plan>;
  chosenPlanPosition: string | null;
  pickAProduct: (pp: string, id: string) => void;
  data: GeneralPaywallMeta;
}

export const PickPlanSectionV2 = (props: PickPlanSectionV2Props) => {
  const { planPositions, stripePlans, chosenPlanPosition, data, pickAProduct } = props;

  return (
    <PickPlanSectionV2Wrapper>
      <PickPlanSectionV2Title>{data?.title}</PickPlanSectionV2Title>

      <PickPlanSectionV2Content>
        <PickPlanSectionV2Products>
          {planPositions.map((pp) => (
            <ProductV3
              key={stripePlans[pp].id}
              product={stripePlans[pp]}
              onClick={() => pickAProduct(pp, stripePlans[pp].id)}
              chosenPlanPosition={chosenPlanPosition ? chosenPlanPosition : WEEKLY_PRICES_TEST_DEFAULT_PLAN_KEY}
            />
          ))}
        </PickPlanSectionV2Products>
      </PickPlanSectionV2Content>
    </PickPlanSectionV2Wrapper>
  );
};
